import React from 'react';
import Shimmer from 'react-shimmer-effect';
import styled from '@emotion/styled';

const CardWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  align-items: flex-start;
  justify-content: center;
  width: 344px;
  min-width: 260px;
  height: 300px;
  box-shadow: 0px 1px 8px 0px rgba(8, 5, 10, 0.1);
  position: relative;
  background-color: #ffffff;
  overflow: hidden;
`;

const CardImage = styled('div')`
  display: flex;
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  width: 100%;
  height: 200px;
  background-color: #f0f0f0;
`;

const InnerContent = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  background: white;
  width: 100%;
  padding: 20px;
  gap: 12px;
  border-bottom-right-radius: 12px;
  border-bottom-left-radius: 12px;
  height: 125px;
  max-height: 125px;
`;

const CardText = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  gap: 12px;
`;

const CardHeaderContainer = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const CardHeader = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 10000px;
  padding: 8px 12px;
  gap: 8px;
  background: #f0f0f0;
  width: 120px;
  height: 24px;
`;

const CardDescription = styled('div')`
  width: 100%;
  height: 40px;
  background: #f0f0f0;
  border-radius: 4px;
`;

const ModuleCardLoading = () => (
  <CardWrapper>
    <Shimmer>
      <CardImage />
    </Shimmer>
    <InnerContent>
      <CardText>
        <CardHeaderContainer>
          <Shimmer>
            <CardHeader />
          </Shimmer>
        </CardHeaderContainer>
        <Shimmer>
          <CardDescription />
        </Shimmer>
      </CardText>
    </InnerContent>
  </CardWrapper>
);

export default ModuleCardLoading;
